import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './slick-carousel-counter.css';

export default class SlickCarouselCounter extends TemplateElement {
	constructor() {
		super({ styles: [style] });
	}

	properties() {
		return {
			currentSlide: 1,
			slideCount: 1,
			slidesToShow: 1,
		};
	}

	template() {
		let fromSlide = this.currentSlide;
		let toSlide = this.currentSlide + this.slidesToShow - 1;
		const difference = toSlide - this.slideCount;
		if (difference > 0) {
			fromSlide -= difference;
			toSlide -= difference;
		}
		return html`
			<span class="current-slide">
				${this.slidesToShow > 1 ? html`${fromSlide} &ndash; ${toSlide}` : `${this.currentSlide}`}
			</span>
			<span class="separator">/</span>
			<span class="slide-count">${this.slideCount}</span>
		`;
	}
}

defineElement('slick-carousel-counter', SlickCarouselCounter);
